'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$81() {
}
export { $c_Lmealorama_jsonCodecs$package$$anon$81 as $c_Lmealorama_jsonCodecs$package$$anon$81 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$81.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$81;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$81() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$81 as $h_Lmealorama_jsonCodecs$package$$anon$81 };
$h_Lmealorama_jsonCodecs$package$$anon$81.prototype = $p;
$p.Q = (function(x) {
  return (false || false);
});
$p.N = (function(x, default$1) {
  if (false) {
    var x586 = x.c2;
    return x.c3.aS(x586).aq();
  } else {
    return default$1.d(x);
  }
});
var $d_Lmealorama_jsonCodecs$package$$anon$81 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$81, "mealorama.jsonCodecs$package$$anon$81", ({
  Kw: 1,
  k: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$81 as $d_Lmealorama_jsonCodecs$package$$anon$81 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$81.js.map
